export default (path: string, body?: object, method = 'POST', isFormData = false): Promise<any> => {
    let payload = null;
    if (body) {
        if (isFormData) {
            const formData = new FormData();

            for (const name in body) {
                if (Object.prototype.hasOwnProperty.call(body, name)) {
                    if (body[name] instanceof FileList) {
                        for (let i = 0; i < body[name].length; i++) {
                            formData.append(name + '[]', body[name][i]);
                        }
                    } else if (body[name] && typeof body[name] === 'object' && !(body[name] instanceof Date)) {
                        for (const key in body[name]) {
                            if (Object.prototype.hasOwnProperty.call(body[name], key)) {
                                formData.append(`${name}[${key}]`, body[name][key]);
                            }
                        }
                    } else {
                        formData.append(name, body[name]);
                    }
                }
            }
            payload = formData;
        } else {
            payload = JSON.stringify(body);
        }
    }

    const options: RequestInit = {
        method,
        credentials: 'include',
        body: payload,
    };

    if (!isFormData) {
        options.headers['Content-Type'] = 'application/json';
    }

    return fetch(path, options)
        .then((res) => res.json())
        .then(async (data) => {
            if (data.success) {
                return data;
            }
            throw new Error(data.message);
        });
};
